export interface IRequestFilters {
    requestNo: string;
    requestingAuthority: string;
    requestedAuthority: string;
    euSecLegBasis: number;
    status: number;
    type: number;
    submissionDateFrom: Date | undefined;
    submissionDateTo: Date | undefined;
    creationDateFrom: Date | undefined;
    creationDateTo: Date | undefined;
    isInitiator: boolean;
}

export class RequestFilters implements IRequestFilters {
    requestNo: string;
    requestingAuthority: string;
    requestedAuthority: string;
    euSecLegBasis: number;
    status: number;
    type: number;
    submissionDateFrom: Date | undefined;
    submissionDateTo: Date | undefined;
    creationDateFrom: Date | undefined;
    creationDateTo: Date | undefined;
    isInitiator: boolean;

    constructor() {
        this.requestNo = "";
        this.requestingAuthority = "";
        this.requestedAuthority = "";
        this.euSecLegBasis = -1;
        this.status = -1;
        this.type = -1;
        this.submissionDateFrom = undefined;
        this.submissionDateTo = undefined;
        this.creationDateFrom = undefined;
        this.creationDateTo = undefined;
        this.isInitiator = false;
    }

    public copyConstructor(requestFilters:IRequestFilters) {
        return ({
            requestNo: requestFilters.requestNo,
            requestingAuthority: requestFilters.requestingAuthority,
            requestedAuthority: requestFilters.requestedAuthority,
            euSecLegBasis: requestFilters.euSecLegBasis,
            status: requestFilters.status,
            type: requestFilters.type,
            submissionDateFrom: requestFilters.submissionDateFrom,
            submissionDateTo: requestFilters.submissionDateTo,
            creationDateFrom: requestFilters.creationDateFrom,
            creationDateTo: requestFilters.creationDateTo,
            isInitiator: requestFilters.isInitiator
        } as IRequestFilters)
    }
}